/* eslint-disable @typescript-eslint/no-unused-vars */
import create from 'zustand'
import produce from 'immer'

const log = (config: any) => (set: any, get: any, api: any) =>
  config(
    (args: any) => {
      set(args)
      // console.log('new state', get())
    },
    get,
    api
  )

const createProposalSlice = (set: any, get: any) => ({
  proposalForm: { stepOne: null, stepTwo: { products: [] } },
  currentStep: 0,
  isEditItemOpen: false,
  selectedItem: {},
  opportunity: {},
  setSelectedItem: (selectedItem: any) => set(() => ({ selectedItem })),
  setIsEditItemOpen: (isEditItemOpen: boolean) =>
    set(() => ({ isEditItemOpen })),

  setProposalStepOne: (data: any) =>
    set(
      produce((draft: any) => {
        draft.proposalForm.stepOne = data
      })
    ),
  setProposalStepTwo: (data: any) =>
    set(
      produce((draft: any) => {
        draft.proposalForm.stepTwo = data
      })
    ),
  setCurrentStep: (step: number) => set(() => ({ currentStep: step })),
  addProposalItems: (data: any) =>
    set(
      produce((draft: any) => {
        const index = draft.proposalForm.stepTwo.products.findIndex(
          (ele: any) => ele.id === data.id
        )
        if (index !== -1) draft.proposalForm.stepTwo.products[index] = data
        else draft.proposalForm.stepTwo.products.push({ ...data })
      })
    ),
  removeProposalItem: (id: any) => {
    set(
      produce((draft: any) => {
        draft.proposalForm.stepTwo.products =
          draft.proposalForm.stepTwo.products.filter(
            (item: any) => item.product.id !== id
          )
      })
    )
  },
  updateProposalItem: (product: any) => {
    set(
      produce((draft: any) => {
        const index = draft.proposalForm.stepTwo.products.findIndex(
          (p: any) => p.product.id === product.product.id
        )
        if (index !== -1) draft.proposalForm.stepTwo.products[index] = product
      })
    )
  },
  resetProposalForm: () =>
    set({
      proposalForm: { stepOne: null, stepTwo: { products: [] } }
    }),
  addProposalAddresses: (data: any) =>
    set(
      produce((draft: any) => {
        const index = draft.proposalForm.stepOne.customer.address.findIndex(
          (ele: any) => ele.id === data.id
        )
        if (index !== -1)
          draft.proposalForm.stepOne.customer.address[index] = data
        else draft.proposalForm.stepOne.customer.address.push({ ...data })
      })
    ),
  setSearchParamOpportunityId: (opportunity: {
    id: string
    opportunityDate: string
  }) => set(() => ({ opportunity }))
})

export const useStore = create(
  log((set: any, get: any) => ({
    ...createProposalSlice(set, get)
  }))
)
